import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/hero";

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const total = heroSlides.length;

  useEffect(() => {
    const timer = setInterval(() => setIndex((i) => (i + 1) % total), 6000);
    return () => clearInterval(timer);
  }, [total]);

  const go = (dir: number) => setIndex((i) => (i + dir + total) % total);
  const slide = heroSlides[index];

  return (
    <section className="relative w-full overflow-hidden bg-primary-950">
      <div className="relative h-[440px] w-full md:h-[600px]">
        {heroSlides.map((s, i) => (
          <div
            key={s.id}
            className={`absolute inset-0 transition-opacity duration-700 ${
              i === index ? "opacity-100" : "opacity-0"
            }`}
          >
            <img
              src={s.backdrop}
              alt={`${s.title} 剧照`}
              title={`${s.title} 焦点推荐`}
              className="h-full w-full object-cover object-top"
            />
          </div>
        ))}

        <div className="absolute inset-0 bg-gradient-to-r from-background-950/85 via-background-950/60 to-background-950/20"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/70 via-transparent to-background-950/20"></div>

        <div className="absolute inset-0">
          <div className="mx-auto flex h-full w-full max-w-7xl flex-col justify-center gap-4 px-4 md:px-6">
            <span className="flex w-fit items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-primary-950">
              <i className="ri-fire-fill"></i>
              {slide.tag}
            </span>
            <h2 className="max-w-2xl text-3xl font-black leading-tight text-background-50 md:text-5xl">
              {slide.title}
            </h2>
            <p className="font-label text-sm text-accent-300 md:text-base">{slide.meta}</p>
            <p className="max-w-xl text-sm leading-relaxed text-background-100/90 md:text-base">
              {slide.desc}
            </p>
            <div className="mt-2 flex flex-wrap items-center gap-3">
              <Link
                to={`/detail/${slide.id}`}
                className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-primary-950 transition-colors hover:bg-accent-400"
              >
                <i className="ri-play-circle-line text-lg"></i>
                查看详情
              </Link>
              <Link
                to="/category/movie"
                className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-100/40 bg-background-950/30 px-5 py-2.5 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-950/50"
              >
                浏览全部影视
              </Link>
            </div>
          </div>
        </div>

        <button
          type="button"
          aria-label="上一张"
          onClick={() => go(-1)}
          className="absolute left-3 top-1/2 hidden h-10 w-10 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-background-950/40 text-background-50 backdrop-blur transition-colors hover:bg-accent-500 hover:text-primary-950 md:flex md:left-6"
        >
          <i className="ri-arrow-left-s-line text-xl"></i>
        </button>
        <button
          type="button"
          aria-label="下一张"
          onClick={() => go(1)}
          className="absolute right-3 top-1/2 hidden h-10 w-10 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-background-950/40 text-background-50 backdrop-blur transition-colors hover:bg-accent-500 hover:text-primary-950 md:flex md:right-6"
        >
          <i className="ri-arrow-right-s-line text-xl"></i>
        </button>

        <div className="absolute bottom-5 left-1/2 flex -translate-x-1/2 items-center gap-2">
          {heroSlides.map((s, i) => (
            <button
              key={s.id}
              type="button"
              aria-label={`切换到第 ${i + 1} 张`}
              onClick={() => setIndex(i)}
              className={`h-1.5 cursor-pointer rounded-full transition-all ${
                i === index ? "w-7 bg-accent-500" : "w-3 bg-background-100/50 hover:bg-background-100"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}